module.exports = __webpack_public_path__ + "static/media/banner_l_02.ad873b1a.jpg";